import { createRoot } from 'react-dom/client';

import browser from '@openclassrooms/utils/browser';
import { getProxifiedUrl, ImageCdn } from '@openclassrooms/images-cdn';

import AppProviders from 'Modules/webapp/components/AppProviders';

const DIRECTIVE_PREFIX = 'data-image-cdn-';
const DIRECTIVE_ATTRIBUTE_PREFIX = `${DIRECTIVE_PREFIX}attr-`;
const DIRECTIVE_ATTRIBUTE_SRC = `${DIRECTIVE_ATTRIBUTE_PREFIX}src`;
const DIRECTIVE_ATTRIBUTE_ALT = `${DIRECTIVE_ATTRIBUTE_PREFIX}alt`;
const DIRECTIVE_BACKGROUND = `${DIRECTIVE_PREFIX}background-image`;
const DIRECTIVE_WIDTH = `${DIRECTIVE_PREFIX}width`;
const DIRECTIVE_HEIGHT = `${DIRECTIVE_PREFIX}height`;

const OTHER_ATTRIBUTES_NAME_MAPPING = {
  class: 'className',
};

const NON_TRANSCLUDED_ATTRIBUTES = [
  DIRECTIVE_WIDTH,
  DIRECTIVE_HEIGHT,
  DIRECTIVE_ATTRIBUTE_SRC,
  DIRECTIVE_ATTRIBUTE_ALT,
];

function getSizeAttributes(element) {
  const sizes = {};

  const widthAttr = element.getAttribute(DIRECTIVE_WIDTH);

  if (widthAttr !== undefined) {
    sizes.width = +widthAttr;
  }

  const heighthAttr = element.getAttribute(DIRECTIVE_HEIGHT);

  if (heighthAttr !== undefined) {
    sizes.height = +heighthAttr;
  }

  return sizes;
}

function getMainAttributes(element) {
  const src = element.getAttribute(DIRECTIVE_ATTRIBUTE_SRC);
  const alt = element.getAttribute(DIRECTIVE_ATTRIBUTE_ALT) || '';
  return { src, alt };
}

function getFinalAttributeName(sourceAttributeName) {
  const attributeName = sourceAttributeName.substr(DIRECTIVE_ATTRIBUTE_PREFIX.length);
  return OTHER_ATTRIBUTES_NAME_MAPPING[attributeName] || attributeName;
}

export const imagePlaceholderToImage = () => {
  const elements = browser.document.querySelectorAll(`[${DIRECTIVE_ATTRIBUTE_SRC}]`);

  [...elements].forEach((element) => {
    const otherAttributes = {};
    const { src, alt } = getMainAttributes(element);
    const elementAttributes = [...element.attributes];

    // Iterate through each element attributes to transclude them if needed
    elementAttributes.forEach((attribute) => {
      if (NON_TRANSCLUDED_ATTRIBUTES.indexOf(attribute.name) > -1) {
        return;
      }

      const attributeStart = attribute.name.substr(0, DIRECTIVE_ATTRIBUTE_PREFIX.length);
      if (attributeStart !== DIRECTIVE_ATTRIBUTE_PREFIX) {
        return;
      }

      const attributeName = getFinalAttributeName(attribute.name);
      otherAttributes[attributeName] = attribute.value;
    });

    const sizeAttributes = getSizeAttributes(element);
    const props = {
      ...sizeAttributes,
      src,
      alt,
      ...otherAttributes,
    };

    const root = createRoot(element);
    root.render(
      <AppProviders productionPrefix="image-cdn">
        <ImageCdn {...props} />
      </AppProviders>
    );
  });
};

export const backgroundPlaceholderToBackground = ({ disableCdn = false }) => {
  const elements = [...browser.document.querySelectorAll(`[${DIRECTIVE_BACKGROUND}]`)];

  elements.forEach((element) => {
    const src = element.getAttribute(DIRECTIVE_BACKGROUND);
    const url = disableCdn ? src : getProxifiedUrl(src);

    // eslint-disable-next-line no-param-reassign
    element.style.backgroundImage = `url(${url})`;
  });
};
